import type { Alpine } from "alpinejs";
import {PrizeStore} from "alpine";
import {activatePrize, getPrize} from "./api.ts";
import {allPrizes} from "./data/prizes.ts";

export function registerPrizeStore(alpine: Alpine) {
    const store: PrizeStore = {
        dialog: null,
        step: 'loading',
        code: '',
        prize: null,
        validating: false,

        form: {
            activationCode: '',
        },
        errors: {},

        async init(): Promise<void> {
            const urlParams = new URLSearchParams(window.location.search);
            const prizeCode = urlParams.get('code') ?? '';

            if (prizeCode === '') {
                return;
            }

            const beer = await getPrize(prizeCode);
            if (beer.prizeResult.status !== 'valid') {
                this.open();
            } else {
                this.step = 'start';
                this.code = prizeCode;
                this.prize = allPrizes.get(beer.prizeResult.type) || null;
            }
        },

        open(): void {
            if (this.dialog && !this.dialog.open) {
                this.dialog.showModal();
            }
        },

        close(): void {
            if (this.dialog?.open) {
                this.dialog.close();
            }
        },

        showForm(): void {
            this.step = 'form';
        },

        async submit(): Promise<void> {
            if (this.validating) {
                return;
            }

            this.validating = true;

            const resetValidation = () =>{
                this.errors = {};
            }

            resetValidation();

            // validate
            if (this.form.activationCode === '') {
                this.errors.activationCode = 'Vyplňte aktivační kód'
            }

            if (Object.keys(this.errors).length > 0) {
                return;
            }

            const result = await activatePrize(this.code, this.form.activationCode);

            this.validating = false;

            if (result.activationResult.status === 'invalid_activation_code') {
                this.errors.activationCode = 'Zadaný kód není platný';

                return;
            }

            if (result.activationResult.status === 'not_found') {
                this.open();
                return;
            }

            this.step = 'success';
        }
    }

    alpine.store('prize', store);
}
